<template>
  <el-dialog :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-login dialog-login-diff">
  	 <div class="el-dialog__header el-dialog__header-diff">
      <span class="el-dialog__title is-active">
        校园端用户登录
      </span>
    </div>
    <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
    <img src="../assets/images/close.png" alt="关闭" @click="loginHandler(false)">
    <el-form :model="ruleForm1" ref="ruleForm1" :rules="rules1" class="el-form-diff">
      <el-form-item prop="challenge" style="display: none">
        <el-input v-model="ruleForm1.challenge" type="hidden"></el-input>
      </el-form-item>
      <el-form-item prop="gt" style="display: none">
        <el-input v-model="ruleForm1.gt" type="hidden"></el-input>
      </el-form-item>
      <el-form-item prop="new_captcha" style="display: none">
        <el-input v-model="ruleForm1.new_captcha" type="hidden"></el-input>
      </el-form-item>
      <el-form-item label="学号：" :label-width="formLabelWidth" prop="stu_no">
        <el-input v-model="ruleForm1.stu_no" autocomplete="off" placeholder="请输入学号" @input="loginValidateFn"></el-input>
      </el-form-item>
      <el-form-item label="密码：" :label-width="formLabelWidth" prop="password">
        <el-input v-model="ruleForm1.password" autocomplete="off" placeholder="请输入密码" :type="passwordType" @input="loginValidateFn">
          <template slot="append">
            <img :src="passwordImg[passwordType]" @click="changeShowPassword">
          </template>
        </el-input>
      </el-form-item>
      <el-form-item class="diff-form-item">
        <div id="geetest"></div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="loginForm" :class="btnActive?'button-active':''">登录</el-button>
    </div>
    <div class="register-box">
      <span @click="goBack">返回</span>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { sendSms, geetest } from "@/api/user";
import { randomToken } from "@/utils/auth.js";
export default {
  name: "Login",
    data() {
      const validateStuNo = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error("请输入学号"));
        } else {
          callback();
        }
      };
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      return {
        formLabelWidth: '76px',
        ruleForm1: {
          stu_no: '',
          password: ''
        },
        passwordImg:{
          "text": require("../assets/images/show.png"),
          "password": require("../assets/images/hidden.png"),
        },
        passwordType: 'password',
        passwordStr: false,
        rules1: {
          stu_no: [
            { validator: validateStuNo, trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
        },
        btnActive: false
      };
    },
    computed: {
      ...mapState({
          // isLogin: state => state.user.isLogin,
          // LOGINSTATUS: state => state.user.LOGINSTATUS,
          // loginError: state => state.user.loginError
      })
    },
    watch: {
      // loginError(val) {
      //   if(val) {
      //     this.btnActive = false
      //     this.initGeetest()
      //   }
      // },
      // isLogin(val) {
      //   if(val) {
      //     this.initGeetest()
      //     this.$nextTick(() => {
      //       this.$refs.ruleForm.resetFields();
      //       this.$refs.ruleForm1.resetFields();
      //     })
      //   }
      // },
      // activeIndex(val) {
      //   this.btnActive = false
      //   if(val == '0' && this.ruleForm1.geetest_challenge) {
      //     this.initGeetest()
      //   }
      // }
    },
    created () {
      // this.initGeetest()
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.resetFields();
      //   this.$refs.ruleForm1.resetFields();
      // })
    },
    methods: {
      loginHandler(isLogin) {
          this.$store.commit("user/SClUSERLOGIN",isLogin);
      },
      loginValidateFn() {
        if(this.ruleForm1.stu_no && this.ruleForm1.password) {
          this.btnActive = true
        } else {
          this.btnActive = false
        }
      },
      loginForm() {
	      // if(!this.ruleForm1.geetest_challenge) {
	      //   // this.$message({
	      //   //   message: '请完成验证',
	      //   //   type: 'warning'
	      //   // })
	      //   return
	      // }
	      this.$refs.ruleForm1.validate((valid) => {
	        if(valid) {
	          this.$store.dispatch('user/SCLLOGIN',{
	            stu_no: this.ruleForm1.stu_no,
	            password: this.ruleForm1.password
	          }).then((res) => {
	            if(!res) {
	              // this.initGeetest()
	            }
	          }).catch(error => {
	              // this.initGeetest()
	              this.$message.error(error);
	          })
	        }
	      })
      },
      changeShowPassword() {
        this.passwordStr = !this.passwordStr;
        this.passwordType = this.passwordStr ? 'text' : 'password';
      },
      goBack() {
        this.$store.commit('user/SClUSERLOGIN', false);
        this.$store.commit('user/LOGINSTATUS', true);
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import "@/assets/css/variables.scss";
  .dialog-box {
    img {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 40px;
      top: 40px;
    }
    .active-line {
      width: 32px;
      height: 4px;
      background: $common-color;
      border-radius: 2px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 15px;
    }
    .dialog-footer {
      padding: 0;
      button {
        width: 496px;
        height: 52px;
        border-radius: 8px;
        margin: 0 auto;
        font-size: 18px!important;
        background: #f0f2f5!important;
        border: none!important;
        position: absolute;
        bottom: 86px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        color: #c4c7cc!important;
      }
      .button-active {
        background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
        color: #ffffff!important;
      }
    }
    .register-box {
      position: absolute;
      bottom: 40px;
      right: 40px;
      span {
        font-size: 16px;
        font-weight: 400;
        color: #5e6166;
        cursor: pointer;
      }
      span:hover {
        color: $common-color;
      }
      span:nth-child(2) {
        padding: 0 8px;
      }
    }
    .diff-form-item {
      background: none!important;
      border: none!important;
      line-height: 0px!important;
      padding: 0px!important;
      height: 44px!important;
    }
  }
</style>